// The content-display entry (UNIVERSAL-CONTENT-DISPLAY). Import from
// '@/app/richEdit/content' — this entry never pulls the editor host or its
// variant engines; check:templates enforces the import graph.

export {
  resolveContentDocument,
  renderContentToSafeHtml,
  escapeContentText,
  registerContentFrame,
  contentFrameStyle,
  type ContentDocument,
  type ContentKind,
  type ContentSourceFields,
  type ContentFrameSpec,
  type ContentFrameBuilder,
} from './contentDocument'

export {
  ContentView,
  registerContentRenderer,
  type ContentViewProps,
  type ContentRenderer,
  type ContentRendererProps,
} from './ContentView'

// LOCKED-SCREEN: the synthetic access-blocked document (never stored;
// surfaces build it from the access grant and render it via ContentView).
export {
  lockedNoticeDocument,
  type LockedNoticeInput,
  type LockedNoticeData,
  type LockedNoticeReason,
  type LockedNoticeDocument,
} from '../serialize/lockedNotice'
